const big_data_error = Symbol('big_data')
// 为了兼容错误
const big_data_error_str = '0000000000'
const big_data_error_num = Number(big_data_error_str)

export {
  big_data_error,
  big_data_error_str,
  big_data_error_num
}